import { ControlType, FormField, FormFieldInit } from "./base";

export class FormFieldToggle extends FormField {
  public override controlType = ControlType.TOGGLE;
  public override initialValue?: boolean | undefined;
  public withBorder?: boolean;

  constructor(init: FormFieldInit<FormFieldToggle>) {
    super(init);
    this.initialValue = init.initialValue ?? false;
    this.withBorder = init.withBorder ?? false;
    this.hasOwnLabel = true;
  }
}
